import { connect } from 'react-redux';
import MsDynamicsView from './MsDynamicsView.jsx';
import { getIntegrationForType, fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import { authenticateAccount,validateInstance, fetchMsDynamicsIntegration, authenticateSecondaryAccount } from 'src/legacy/redux/actions/integrations/msDynamics.jsx';  
import {trackAdoptionMetricsForPluginConnectedEvent} from 'src/legacy/redux/actions/adoption';
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'ms_dynamics_v2');
  return {
    integration: integration,
    integrations: state.legacyRootReducer.settings.integrations,
    user: state.users.me,
    authenticating:state.legacyRootReducer.settings.integrations.msDynamics.authentication.authenticating,
    errors: state.legacyRootReducer.settings.integrations.msDynamics.authentication.error,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
    integrationsLoading: _.get(state.legacyRootReducer.settings.integrations, 'activated.loading' ,false)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (code, instanceUrl) => {
      return dispatch(authenticateAccount(code, instanceUrl));
    },
    authenticateSecondaryAccount: (id, code, instanceUrl) => {
      return dispatch(authenticateSecondaryAccount(id, code, instanceUrl));
    },
    validateInstance: (instanceUrl)=>{
      return dispatch(validateInstance(instanceUrl))
    },
    fetchMsDynamicsIntegration: () =>{
      return dispatch(fetchMsDynamicsIntegration())
    },
    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
  }
}

const MsDynamicsPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(MsDynamicsView);

export default withUseHooks(MsDynamicsPage);
